module.exports = __webpack_public_path__ + "img/50.a362e3b6.jpg";